// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zF2Bs","cardBody":"Card_cardBody__mYKKB"};